import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatSlug(str: string | undefined): string {
  if (!str) return '';
  return str
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function formatTaskName(name: string | undefined): string {
  if (!name) return '';
  // Check if it's kebab-case (contains hyphens and no spaces)
  if (name.includes('-') && !name.includes(' ')) {
    return name
      .split('-')
      .map((word, index) => {
        const lowercaseWords = ['at', 'the', 'and', 'or', 'in', 'on', 'with', 'by', 'of', 'for'];
        if (index > 0 && lowercaseWords.includes(word.toLowerCase())) {
          return word.toLowerCase();
        }
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');
  }
  return name;
}

export function getItemPrice(item: any): number {
  let price = item.price;
  if (item.pricing?.targetPrice?.minorUnits) {
    price = Number(item.pricing.targetPrice.minorUnits) / 100;
  } else if (item.pricing?.unitCost?.minorUnits) {
    price = Number(item.pricing.unitCost.minorUnits) / 100;
  } else if (typeof price === 'string') {
    price = Number(price);
  } else if (typeof price === 'object' && price !== null && 'minorUnits' in price) {
    price = Number(price.minorUnits) / 100;
  }
  if (typeof price !== 'number' || isNaN(price)) {
    price = 0;
  }
  return price;
}
